module.exports = __webpack_public_path__ + "static/img/3.26dd001.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/9/eng/3.png
// module id = 0kzs
// module chunks = 0